export enum FrontendModalSize {
  default = 'default',
  wider = 'wider',
  wide = 'wide',
}
